import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { getFirestore, collection, addDoc, getDocs } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBSkOQ3o4fsd7P1H1fw2DNbmbrbcYAYN9I",
  authDomain: "rvcg-calendar-app.firebaseapp.com",
  projectId: "rvcg-calendar-app",
  storageBucket: "rvcg-calendar-app.firebasestorage.app",
  messagingSenderId: "613109437131",
  appId: "1:613109437131:web:f150b53036fe8d57f2414e"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const signInWithGoogle = () => signInWithPopup(auth, provider);
export const firebaseConfig1 = {
  apiKey: "AIzaSyBSkOQ3o4fsd7P1H1fw2DNbmbrbcYAYN9I",
  authDomain: "rvcg-calendar-app.firebaseapp.com",
  projectId: "rvcg-calendar-app",
  storageBucket: "rvcg-calendar-app.firebasestorage.app",
  messagingSenderId: "613109437131",
  appId: "1:613109437131:web:f150b53036fe8d57f2414e"
};
export default app;